import type { components } from '@/api'
import { get, post, remove } from './client'
import type { BackendMeta } from './types'

type DeleteHub = BackendMeta<'/api/workspaces/{workspace_id}/hubs/{hub_id}', 'delete'>

async function deleteHub(workspaceId: string, hubId: string) {
  return remove<DeleteHub['queryParams'], DeleteHub['successResponse'], DeleteHub['path']>(
    `/api/workspaces/${workspaceId}/hubs/${hubId}`,
    undefined,
  )
}

type CreateHubPath = `/api/workspaces/${string}/hubs`
type CreateHubResponse = components['schemas']['Hubs.HubResponse']
export type CreateHubRequest = components['schemas']['Hubs.CreateHubRequest']

const createHub = (workspaceId: string, payload: CreateHubRequest) =>
  post<CreateHubRequest, CreateHubResponse, CreateHubPath>(
    `/api/workspaces/${workspaceId}/hubs`,
    payload,
  )

type ListHubsMeta = BackendMeta<'/api/workspaces/{workspace_id}/hubs', 'get'>

function listHubs(workspaceId: string) {
  return get<ListHubsMeta['queryParams'], ListHubsMeta['successResponse'], ListHubsMeta['path']>(
    `/api/workspaces/${workspaceId}/hubs`,
    undefined,
  )
}

type GetHubMeta = BackendMeta<'/api/workspaces/{workspace_id}/hubs/{hub_id}', 'get'>
function getHub(workspaceId: string, hubId: string) {
  return get<GetHubMeta['queryParams'], GetHubMeta['successResponse'], GetHubMeta['path']>(
    `/api/workspaces/${workspaceId}/hubs/${hubId}`,
    undefined,
  )
}

type ReindexHubMeta = BackendMeta<'/api/workspaces/{workspace_id}/hubs/{hub_id}/reindex', 'post'>
function reindexHub(workspaceId: string, hubId: string) {
  return post<
    ReindexHubMeta['queryParams'],
    ReindexHubMeta['successResponse'],
    ReindexHubMeta['path']
  >(`/api/workspaces/${workspaceId}/hubs/${hubId}/reindex`, undefined)
}

export const HubsAPI = {
  createHub,
  deleteHub,
  listHubs,
  getHub,
  reindexHub,
}
